import { Button } from "@/components/Core/Button";
import RenderToast from "components/Core/RenderToast";
import { validateEmail } from "constant/regex";
import { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./OtpModal.module.css";
const OtpModal = ({
  show,
  setShow,
  email,
  handleOtpFunc,
  isOtpSend,
  resendOtp,
  resendOtpLoader,
}) => {
  const [otp, setOtp] = useState("");
  const [seconds, setSeconds] = useState(120);

  const handleSubmit = async () => {
    const params = {
      code: Number(otp),
      email,
    };
    if (!validateEmail(params?.email)) {
      return RenderToast({
        type: "error",
        message: "Please enter correct email",
      });
    }
    for (let key in params) {
      if (!params[key]) {
        return RenderToast({
          type: "error",
          message: `Please insert the OTP code`,
        });
      }
    }
    if (String(params?.code)?.length < 6) {
      return RenderToast({
        type: "error",
        message: `Otp code is incomplete!`,
      });
    }
    await handleOtpFunc(params);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(seconds - 1 > 0 ? seconds - 1 : "00");
    }, 1000);
    return () => clearInterval(interval);
  }, [seconds]);
  return (
    <>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        header={"OTP Verification"}
        headerClass={classes.heading}
        width={"500px"}
      >
        <div className={classes.OtpInput_main}>
          <p>Enter the One Time Password sent to</p>
          <p>{email}</p>
          <div>
            <OtpInput
              value={otp}
              onChange={setOtp}
              inputStyle={classes.OtpInput_style}
              numInputs={6}
              isInputNum={true}
              shouldAutoFocus={true}
              renderInput={(props) => <input {...props} />}
            />
          </div>
          <p className={classes.resendContainer}>
            {seconds !== "00" && (
              <>
                Your OTP code will expire in{" "}
                <span className={classes.timer}>
                  {` ${String(Math.floor(seconds / 60)).padStart(
                    2,
                    "0"
                  )}:${String(seconds % 60).padStart(2, "0")}`}
                </span>
              </>
            )}
            {seconds == "00" && (
              <>
                Your OTP code has expired.
                <span
                  onClick={async () => {
                    if (resendOtpLoader || isOtpSend) return;
                    await resendOtp(email);
                    setSeconds(120);
                  }}
                  className={classes.resend}
                >
                  {resendOtpLoader ? "Resending..." : "Resend OTP"}
                </span>
              </>
            )}
          </p>
          <Button
            disabled={isOtpSend || resendOtpLoader}
            onClick={handleSubmit}
            label={isOtpSend ? "Verifying..." : "Verify"}
            className={classes.verify_btn}
          />
        </div>
      </ModalSkeleton>
    </>
  );
};

export default OtpModal;
